<template>
  <div>
    <v-card>
      <v-card-text>
        <v-data-table hide-actions
            :loading="loading"
            :headers="headers"
            :items="loadedItems"
            class="elevation-0"
          >
          <template slot="headers" slot-scope="props">
            <tr>
              <th v-for="header in props.headers" :key="header.text" :class="`text-xs-${header.align}`">
                {{ header.text }}
              </th>
              <th class="text-xs-right">
                <v-btn fab dark small color="primary" class="text-xs-center" :to="`/receipts/add/invoice/${value.id}`">
                  <v-icon dark>playlist_add</v-icon>
                </v-btn>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.index + 1 }}</td>
            <td class="text-xs-left" nowrap>{{ props.item.code }}</td>
            <td class="text-xs-left">
              {{ props.item.name }}
            </td>
            <td class="text-xs-left">
              {{ props.item.customer.name }}
            </td>
            <td class="text-xs-center">{{ props.item.bookDate | formatShortDate }}</td>
            <td class="text-xs-right">{{ props.item.totalPriceAmount | currency('',2) }}</td>
            <td class="text-xs-right">{{ props.item.totalVatAmount | currency('',2) }}</td>
            <td class="text-xs-right">{{ props.item.totalAmount | currency('',2) }}</td>
            <td class="text-xs-center">
              <v-chip small outline :color="$options.filters.statusBgColor(props.item.status)">{{ props.item.status }}</v-chip>
            </td>
            <td class="text-xs-center">
              <v-layout>
                <v-tooltip left>
                  <v-btn icon class="mx-0" slot="activator" :href="printoutUrl(props.item.id)" target="_blank">
                    <v-icon small color="indigo">cloud_download</v-icon>
                  </v-btn>
                  <span>Download</span>
                </v-tooltip>
                <v-tooltip left>
                  <v-btn icon class="mx-0" slot="activator" @click="print(props.item.id)">
                    <v-icon small color="blue">print</v-icon>
                  </v-btn>
                  <span>Print</span>
                </v-tooltip>
                <v-tooltip left>
                  <v-btn icon class="mx-0" slot="activator" :to="`/receipts/${props.item.id}`">
                    <v-icon small color="teal">zoom_in</v-icon>
                  </v-btn>
                  <span>แก้ไข {{props.item.code}}</span>
                </v-tooltip>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ReceiptList',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      loadedItems: (this.value.receipts) ? this.value.receipts : [],
      headers: [
        { text: '#', sortable: false, align: 'center' },
        { text: 'Code', value: 'code', sortable: true, align: 'left' },
        { text: 'Name', value: 'name', sortable: true, align: 'left' },
        { text: 'Customer', value: 'customer.name', sortable: true, align: 'left' },
        { text: 'Date', value: 'bookDate', sortable: true, align: 'center' },
        { text: 'Price', value: 'totalPriceAmount', sortable: false, align: 'right' },
        { text: 'Vat', value: 'totalVatAmount', sortable: false, align: 'right' },
        { text: 'Total', value: 'totalAmount', sortable: false, align: 'right' },
        { text: 'Status', value: 'status', sortable: true, align: 'center' }
      ]
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  methods: {
    printoutUrl (id) {
      return this.$store.getters['receipt/printoutUrl'](id)
    },
    print (id) {
      this.$store.dispatch('printPdf', this.printoutUrl(id))
    }
  },
  watch: {
    value () {
      this.loadedItems = (this.value.receipts) ? this.value.receipts : []
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/invoices/receiptList.vue